import React from 'react';
import { FileTextIcon } from 'lucide-react';
export function MSeriesSection() {
  return <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-779">
      <div className="bg-[#002d4d] text-white py-6 px-8 flex flex-col md:flex-row md:items-center justify-between" data-id="element-780">
        <div data-id="element-781">
          <h2 className="text-3xl font-bold mb-1" data-id="element-782">Bodor M Series</h2>
          <h3 className="text-white/80 font-medium text-lg" data-id="element-783">
            Multi-Chuck Fiber Laser Tube Cutting Machine
          </h3>
        </div>
      </div>

      <div className="p-8" data-id="element-784">
        <div className="grid md:grid-cols-12 gap-12 items-center" data-id="element-785">
          <div className="md:col-span-5 flex flex-col items-center bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-786">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/BODOR/Laser%20Tube%20Cutter/Bodor%20M%20Series%20Laser%20Tube%20Cutting%20Machine.PNG" alt="Bodor M Series" className="block max-h-[350px] w-auto object-contain drop-shadow-xl mb-4" data-id="element-787" />
            <span className="bg-[#f5693d] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider text-center" data-id="element-788">
              Flagship Laser Tube Cutting Machine
            </span>
          </div>
          <div className="md:col-span-7" data-id="element-789">
            <ul className="space-y-4 text-gray-700" data-id="element-790">
              <li data-id="element-791">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-792">
                  Heavy Tube Laser Cutting Machine
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-793">
                  Loads up to 1,800 kg - tube length up to 12 meters - Clamping
                  Size up to 450mm (17.75in)
                </span>
              </li>
              <li data-id="element-794">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-795">
                  No Material Waste
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-796">
                  Equipped with four chucks, the cutting cost is saved without
                  wasting materials
                </span>
              </li>
              <li data-id="element-797">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-798">
                  Bevel Cutting
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-799">
                  Bevel cutting within an angle of ±45°, enable workpieces to be
                  seamlessly spliced.
                </span>
              </li>
              <li data-id="element-800">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-801">
                  Automatic Loading &amp; Unloading
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-802">
                  Fully intelligent, cutting starts by just one click, with the
                  servo separating materials accurately and feeding tubes as
                  quick as a flash.
                </span>
              </li>
              <li data-id="element-803">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-804">
                  Expert High Speed Cutting Database
                </strong>
              </li>
              <li data-id="element-805">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-806">
                  Bodor Thinker 4.0T
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-807">
                  EtherCAT bus control system boosts the response speed of M
                  Series to 6 times faster.
                </span>
              </li>
              <li data-id="element-808">
                <strong className="text-[#002d4d] block text-lg mb-1" data-id="element-809">
                  Intelligent NC Chuck
                </strong>
                <span className="text-gray-600 ml-4 block border-l-2 border-gray-200 pl-3" data-id="element-810">
                  Servo controls both position and moment, keeping chucks
                  accurate without deformation.
                </span>
              </li>
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 mt-8 pt-6 border-t border-gray-100" data-id="element-811">
              <span className="inline-flex items-center justify-center px-6 py-3 bg-[#002d4d] text-white font-bold uppercase text-sm rounded-md opacity-80 cursor-not-allowed" data-id="element-812">
                <span className="mr-2" data-id="element-813">+</span> Discover More
              </span>
              <span className="inline-flex items-center justify-center px-6 py-3 border-2 border-[#002d4d] text-[#002d4d] font-bold uppercase text-sm rounded-md opacity-80 cursor-not-allowed" data-id="element-814">
                <FileTextIcon className="w-4 h-4 mr-2" data-id="element-815" /> Download Brochure
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}